import { useAPIMutation } from "@/services/api/hook";
import {
  GlobalSearchRequest,
  GlobalSearchResponse,
  GlobalSearchFilterTypes,
  GlobalSearchEntityTypes,
  GlobalSearchSortBy,
  FILTER_TO_ENTITY_TYPES
} from "../types";

export const useGlobalSearchMutation = () => {
  return useAPIMutation<GlobalSearchRequest, GlobalSearchResponse>(
    "search/global",
    {
      method: "POST"
    }
  );
};

export const prepareSearchRequest = (
  query: string,
  activeFilter: GlobalSearchFilterTypes,
  page: number = 1,
  pageSize: number = 20,
  sortBy: GlobalSearchSortBy = "relevance",
  enabledEntityTypes?: GlobalSearchEntityTypes[],
  queryBy?: string
): GlobalSearchRequest => {
  const allEntityTypes =
    enabledEntityTypes ?? Object.values(GlobalSearchEntityTypes);

  // Constrain explicit filters to the enabled set so a disabled entity type
  // (e.g. CONTRACTS behind a feature flag) can never be requested from the API.
  const filterAsEntity = activeFilter as unknown as GlobalSearchEntityTypes;
  const mergedEntityTypes = FILTER_TO_ENTITY_TYPES[activeFilter];

  let scopedEntityTypes: GlobalSearchEntityTypes[];
  if (activeFilter === GlobalSearchFilterTypes.ALL) {
    scopedEntityTypes = allEntityTypes;
  } else if (mergedEntityTypes !== undefined) {
    scopedEntityTypes = mergedEntityTypes.filter((entityType) =>
      allEntityTypes.includes(entityType)
    );
  } else if (allEntityTypes.includes(filterAsEntity)) {
    scopedEntityTypes = [filterAsEntity];
  } else {
    scopedEntityTypes = allEntityTypes;
  }

  const request: GlobalSearchRequest = {
    query,
    page,
    pageSize,
    sortBy,
    entityTypes: scopedEntityTypes,
    includeLookupTables: false,
    includeFields: "*"
  };

  // Omitted rather than sent empty: the API treats a missing queryBy as "match
  // every indexed field", which is what app-wide search wants.
  if (queryBy) {
    request.queryBy = queryBy;
  }

  return request;
};
